import { atom } from 'recoil'

export const editorState = atom({
  key: 'messageEditEditorState',
  default: {
    dirty: false,
    saved: true,
    thirdPartyAccepted: false,
    messageAutoSave: undefined,
    concurrentAccessUsername: undefined,
    loadPluginChecked: false,
    saveToLists: [],
    resume: false,
    mode: undefined,
    //
    mergeTags: [],
    mergeTagsWhitelist: [],
    //
    afterSaveCallback: undefined,
    id: undefined,
    subject: undefined,
    messageType: undefined,
    welcomeSeriesInfo: undefined,
    lastContent: '',
    template: undefined,
    idTemplate: undefined
  }
})

export const beePluginState = atom({
  key: 'messageEditBeePluginState',
  default: {
    instance: undefined,
    loaded: false
  }
})

export const openAIState = atom({
  key: 'messageEditBeePluginidopenAIState',
  default: {
    totalTokens: null,
    remainingTokens: null,
    enableUse: false,
    showBuy: false,
    loaded: false
  }
})
